import serialize from "json-form-data";
import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

const formatAnalyseData = (data) =>
    serialize({
        name: data.name,
        type_id: data.type.value,
        expire_in_days: data.expireInDays,
        comment: data.comment,
        posts_all_except: data.postsAllExcept,
        posts: data.posts.map((item) => item.value),
    });

const state = () => ({
    positionLoading: false,

    analysesTypes: [],
    analysesTypesRaw: [],
    positions: [],
});

const getters = {
    getAnalysesByTypeId: (state) => (typeId) => state.analysesTypesRaw.find((type) => type.id === typeId).analyses,
    getAnalyseTypeByAnalyseId: (state) => (analyseId) =>
        state.analysesTypesRaw.find((type) => type.analyses.find((analyse) => analyse.id === analyseId)),
    getAnalyseTypeNameById: (state) => (typeId) => state.analysesTypesRaw.find((type) => type.id === typeId).name,
    getAnalysesTypesRaw: (state) => state.analysesTypesRaw,
    getAnalyses: (state) => {
        const analyses = [];
        state.analysesTypesRaw.forEach((type) => {
            type.analyses.forEach((analyse) => {
                analyses.push({
                    value: analyse.id,
                    label: analyse.name,
                    group: analyse.type_id,
                });
            });
        });
        return analyses;
    },
    getNotEmptyAnalysesTypes: (state) =>
        state.analysesTypesRaw
            .filter((item) => item.analyses.length)
            .map((item) => ({
                label: item.name,
                value: item.id,
                name: item.id,
            })),
};

const actions = {
    async fetchAnalysesTypes({ commit, rootState }) {
        const token = rootState.authToken;

        const { data } = await axios.get(addAuthKey(`${api_url}/?r=api/medical-analysis-types/index`, token));

        commit("setAnalysesTypes", data);
    },
    async fetchPositions({ commit, state, rootState }) {
        if (state.positionLoading) return;

        const token = rootState.authToken;
        const { data } = await axios.get(addAuthKey(`${api_url}/?r=api/worker-profile/posts-list`, token));

        commit("setPositions", data);
    },
    async createAnalyse({ rootState }, params) {
        const token = rootState.authToken;
        const formData = formatAnalyseData(params);

        const { data } = await axios.post(addAuthKey(`${api_url}/?r=api/medical-analysis/create`, token), formData);

        return data;
    },
    updateAnalyse({ rootState }, params) {
        const token = rootState.authToken;
        const formData = formatAnalyseData(params);

        return axios.put(addAuthKey(`${api_url}/?r=api/medical-analysis/update&id=${params.id}`, token), formData);
    },
    changeAnalyseType({ rootState }, params) {
        const token = rootState.authToken;
        const formData = serialize({ type_id: params.typeId });

        return axios.put(addAuthKey(`${api_url}/?r=api/medical-analysis/update&id=${params.id}`, token), formData);
    },
    async fetchAnalyseById({ rootState }, params) {
        const token = rootState.authToken;

        const { data } = await axios.get(addAuthKey(`${api_url}/?r=api/medical-analysis-types/index`, token));

        let fetchedAnalyse = {};
        data.forEach((category) => {
            category.analyses.forEach((analyse) => {
                if (analyse.id === +params.id) {
                    fetchedAnalyse = { ...analyse };
                }
            });
        });

        return fetchedAnalyse;
    },
    async fetchAnalysesForReport({ getters, dispatch, state }) {
        if (!state.analysesTypesRaw.length) {
            await dispatch("fetchAnalysesTypes");
        }

        return {
            groups: getters.getNotEmptyAnalysesTypes,
            items: getters.getAnalyses,
        };
    },
};

const mutations = {

    enableSpecialitiesLoading(state) {
        state.specialitiesLoading = true;
    },
    setAnalysesTypes(state, data) {
        state.analysesTypes = data.map((item) => ({
            label: item.name,
            value: item.id,
        }));
        state.analysesTypesRaw = data;
    },
    setPositions(state, { response }) {
        const positions = [];

        response.forEach((position) => {
            positions.push({
                label: position.name,
                value: position.id,
            });
        });

        state.positions = positions;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
